import { render, staticRenderFns } from "./DebtList.vue?vue&type=template&id=11986114&"
import script from "./DebtList.vue?vue&type=script&lang=js&"
export * from "./DebtList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports